import MathTool from '../math/MathTool.js';

export default class SVGToGcode{
    /*
        x0: left-top horizontal corner of plotter area
        y0: left-top horizontal corner of plotter area
        x1: right-bottom horizontal corner of plotter area
        x01 right-bottom horizontal corner of plotter area
    */
    constructor( svgSelector, x0, y0, x1, y1/* , zWork, zFly, zPark */ ){
        this.flySpeed = 12000;
        this.moveSpeed = 12000;
        this.zSpeed = 2000;
        this.homeCmd = 'G1  X0 Y0';//'G28';
        this.flyCmd = 'G0';
        this.moveCmd = 'G1'
        this.penUpCmd = 'M5';
        this.penDownCmd = 'M3 S1000';
        this.pauseCmd = 'G4 P0.15000000298023224'; //'G4 P0.20000000298023224';
        this.svgElement = document.querySelector(svgSelector);
        this.originX = 0;
        this.originY = 0;
        this.originWidth = Number( this.svgElement.getAttribute('width') );
        this.originHeight = Number( this.svgElement.getAttribute('height') );
        this.x0 = x0 || 0;
        this.y0 = y0 || 0;
        this.x1 = x1 || Number( this.svgElement.getAttribute('width') );
        this.y1 = y1 || Number( this.svgElement.getAttribute('height') );
        /* this.zWork = zWork || 0;
        this.zFly = zFly || 10;
        this.zPark = zPark || 20; */

        this.gcode = "";

        let paths = this.svgElement.querySelectorAll('path');
        /* let gcode = `G00 S1; endstops
G00 E0; no extrusion
G01 S1; endstops
G01 E0; no extrusion
G21; millimeters
G90; absolute
G28; home
G0 F${this.zSpeed} Z${this.zPark}
`; */   
        let gcode = `M5	;PEN UP
        G1 F12000 ;SET SPEED
        G1  X0 Y0 ;MOVE TO HOME
`;
        for (let i = 0; i < paths.length; i++) {
            const path = paths[i];
            let commands = path.getAttribute('d');
            let pathCommands = this.parsePathCommands( commands );
            let pathGcode = this.commandsToGcode( pathCommands );
            gcode += pathGcode + '\n';
        }
        //console.log( "gcode:" );
        //console.log( gcode );
        this.gcode = gcode;
    }

    commandsToGcode( pathCommands ){
        let gcode = [];
        for (let i = 0; i < pathCommands.length; i++) {
            const command = pathCommands[i];
            if( command.cmd == 'M' ){
                gcode.push( this.pauseCmd );
                gcode.push( this.penUpCmd );
                gcode.push( this.pauseCmd );
                gcode.push( this.flyCmd + ' F' + this.flySpeed + ' X' + command.x + ' Y' + command.y );
                gcode.push( this.pauseCmd );
                gcode.push( this.penDownCmd );
                gcode.push( this.pauseCmd );
                /* gcode.push( this.flyCmd + ' F' + this.zSpeed + ' Z' + this.zFly );
                gcode.push( this.flyCmd + ' F' + this.flySpeed + ' X' + command.x + ' Y' + command.y );
                gcode.push( this.flyCmd + ' F' + this.zSpeed + ' Z' + this.zWork ); */
            }else if( command.cmd == 'L' ){
                gcode.push( this.moveCmd + ' F' + this.moveSpeed + ' X' + command.x + ' Y' + command.y );
            }
        }
        //gcode.push( this.flyCmd + ' F' + this.zSpeed + ' Z' + this.zFly );
        gcode.push( this.penUpCmd );
        gcode = gcode.join('\n');
        return gcode;
    }

    parsePathCommands( cmds ){
        cmds = cmds.split(' ');
        let results = [];
        let currentItem;
        // Extract commands
        for( let i=0; i<cmds.length; i++ ){
            let cmd = cmds[i];
            if( cmd == 'M' ){
                //currentItem.cmd = `G0 X${cmds[i+1]} Y${cmds[i+2]}`
                currentItem = { cmd: "M", x:Number(cmds[i+1]), y:Number(cmds[i+2]) };
                results.push( currentItem );
                i+=2;
            }else if( cmd == 'L' ){
                //currentItem.cmd = `G0 X${Number(cmds[i+1])} Y${Number(cmds[i+2])}`
                currentItem = { cmd: "L", x:Number(cmds[i+1]), y:Number(cmds[i+2]) };
                results.push( currentItem );
                i+=2;
            }else if( cmd == 'Z' ){
                //currentItem.cmd = `G0 X${cmds[i+1]} Y${cmds[i+2]}`
                
            }
        }
        // Adjust positions to plotter print area (projection)
        for (let i = 0; i < results.length; i++) {
            const item = results[i];
            item.x = MathTool.map( item.x, this.originX, this.originWidth, this.x0, this.x1 );
            item.y = MathTool.map( item.y, this.originHeight, this.originY, this.y0, this.y1 );            
        }
        return results;

        // Generate g-code
        console.log( results);
        
    }
}